import { Box, Typography, useTheme, Chip } from "@mui/material";
import { tokens } from "../theme";
import ProgressCircle from "./ProgressCircle";

const StatBox = ({ title, subtitle, icon, progress, increase }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box width="100%">
      <Box display="flex" justifyContent="space-between" alignItems="flex-start">
        <Box>
          <Box
            sx={{
              width: 42,
              height: 42,
              borderRadius: "12px",
              display: "grid",
              placeItems: "center",
              mb: 1.5,
              bgcolor: theme.palette.mode === "dark" ? "rgba(112, 216, 189, .12)" : "rgba(61, 165, 138, .12)",
            }}
          >
            {icon}
          </Box>
          <Typography variant="body2" sx={{ color: colors.grey[300], fontWeight: 600 }}>
            {subtitle}
          </Typography>
        </Box>
        <Chip
          label={increase}
          size="small"
          sx={{
            color: colors.greenAccent[400],
            border: `1px solid ${colors.greenAccent[700]}`,
            bgcolor: "transparent",
            fontWeight: 700,
          }}
        />
      </Box>
      <Typography variant="h3" fontWeight={800} sx={{ color: colors.grey[100], mt: 1 }}>
        {title ?? "—"}
      </Typography>
    </Box>
  );
};

export default StatBox;
